import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { rememberEntryUrl } from './app/chunk-reload';
import { installAuthStorageProbe } from './app/user/auth-storage-probe';
import { environment } from './environments/environment';

// vor dem Router: der ChunkErrorHandler laedt bei einem Chunk-Fehler der ersten Navigation diese URL neu
rememberEntryUrl();
// vor provideAuth/initializeAuth: beobachtet die Lese-/Schreibzugriffe des Auth-SDK auf den gespeicherten Nutzer
// (workorder-auth-drop-ios-diagnostics-2026-11-03) - nur messen, Rueckgabewerte unveraendert
installAuthStorageProbe();

if (environment.production) {
  enableProdMode();
}

function bootstrap() {
  platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));
};


 if (document.readyState === 'complete') {
   bootstrap();
 } else {
   document.addEventListener('DOMContentLoaded', bootstrap);
 }
 
